export default __webpack_public_path__ + "static/media/arrowNext.e63bfd74.svg";